var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.68 13.337h2.665l.527-3.757H13.68V7.36c0-.49.104-.946.37-1.28.264-.33.7-.555 1.395-.555H17V2.288l-.135-.027-.168-.031a16 16 0 0 0-.593-.094A13 13 0 0 0 14.338 2c-1.322 0-2.427.442-3.202 1.286s-1.209 2.08-1.209 3.647V9.58H7v3.757h2.927V22h3.753z"
})));
export default SvgFacebook;